import {tokens} from '@pleo-io/telescope'
import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import {LegalDocumentsGridFragment} from '@/graphql-types'
import PrismicLink from '@helios/shared/components/prismic-link'
import {Section, Layout, TitleLayout} from '@helios/shared/styles/grid'
import {Text, text} from '@helios/shared/styles/typography'
import {focusStyles} from '@helios/shared/styles/utils'
import {colors} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

type LegalDocumentsGridProps = {
    content: LegalDocumentsGridFragment
}

const LegalDocumentsGrid = ({content}: LegalDocumentsGridProps) => (
    <Section>
        <DocumentsTitleWrapper>
            <Text variant="heading-base">{content.data.title}</Text>
        </DocumentsTitleWrapper>

        <Layout variant="three-equal">
            {content.data.documents.map((document, i) => {
                return (
                    <Document as={PrismicLink} {...document.link} key={`${document.title}-${i}`}>
                        <Text>{document.title}</Text>
                        <TextLikeLink>{document.link_text}</TextLikeLink>
                    </Document>
                )
            })}
        </Layout>
    </Section>
)

const DocumentsTitleWrapper = styled(TitleLayout)`
    margin-bottom: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-bottom: ${tokens.spacing40};
    }
`

const Document = styled.div`
    display: grid;
    align-content: space-between;
    row-gap: ${tokens.arc8};
    padding: ${tokens.spacing20};
    background: ${colors.background.muted};
    border: 1px solid transparent;
    border-radius: ${tokens.arc8};

    :hover,
    :active {
        cursor: pointer;
        border-color: ${colors.border.secondary};
    }

    :focus {
        ${focusStyles()}
    }
`

const TextLikeLink = styled.p`
    ${text({variant: 'paragraph-large'})}
    text-decoration: underline;
`

export const legalDocumentsGridFragment = graphql`
    fragment LegalDocumentsGrid on PrismicLegalDocuments {
        data {
            title
            documents {
                title
                link {
                    ...PrismicLink
                }
                link_text
            }
        }
    }
`

export default LegalDocumentsGrid
